import { getListOfAccounts } from "../types/account_list_types";

export const getListOfAccountsRequest = (payload, cb) => ({
  type: getListOfAccounts.GET_LIST_OF_ACCOUNTS_REQUEST,
  payload,
  cb,
});
export const getListOfAccountsSuccess = (payload) => ({
  type: getListOfAccounts.GET_LIST_OF_ACCOUNTS_SUCCESS,
  payload,
});
export const getListOfAccountsError = (payload) => ({
  type: getListOfAccounts.GET_LIST_OF_ACCOUNTS_ERROR,
  payload,
});
